import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {AppRoutingModule} from './app-routing.module';

import {ServiceWorkerModule} from '@angular/service-worker';
import {AppComponent} from './app.component';

import {environment} from '../environments/environment';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TopNavbarComponent} from './top-navbar/top-navbar.component';
import {StoreModule} from '@ngrx/store';
import {reducers} from './reducers';
import {FormFilterComponent} from './form-filter/form-filter.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {EffectsModule} from '@ngrx/effects';
import {YearEffects} from './effects/yearEffects';
import {ReactiveFormsModule} from '@angular/forms';
import {StateEffects} from './effects/stateEffects';
import {CountyEffects} from './effects/countyEffects';
import {PriceDiscoveryComponent} from './price-discovery/price-discovery.component';
import {PriceDiscoveryEffects} from './effects/PriceDiscoveryEffects';
import {PriceDiscoveryCardComponent} from './price-discovery/price-discovery-card/price-discovery-card.component';
import {DetailsComponent} from './price-discovery/price-discovery-card/details/details.component';
import {OrderByPipe} from './pipes/orderBy/order-by.pipe';
import {CommoditiesEffects} from './effects/commoditiesEffects';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {AuthInterceptor} from './services/request.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    TopNavbarComponent,
    FormFilterComponent,
    PriceDiscoveryComponent,
    PriceDiscoveryCardComponent,
    DetailsComponent,
    OrderByPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatSidenavModule,
    MatTabsModule,
    MatToolbarModule,
    ReactiveFormsModule,
    NgbModule,
    StoreModule.forRoot(reducers),
    environment.imports,
    EffectsModule.forRoot([YearEffects, StateEffects, CountyEffects, PriceDiscoveryEffects, CommoditiesEffects]),
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production})
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
